module.exports = __webpack_public_path__ + "img/p-one-step-03.f81d20cb.png";